import { Row, Col, Card } from "antd";
import AccountStatementForm from "@/views/accounts/AccountStatementForm";
import YourTransaction from "@/views/accounts/YourTransaction";
import {useAuthUser} from "@/modules/auth/context/AuthContext";

function AccountActivity() {
    const  authUser =useAuthUser();
    console.log(authUser);

  return (
    <>
      <Row gutter={[24, 0]}>
            <Col span={24} md={8} className="mb-24">
              <Card
                bordered={false}
                bodyStyle={{ paddingTop: 0 }}
                className="header-solid h-full  ant-list-yes"
                title={<h6 className="font-semibold m-0">Account Statement</h6>}
                extra={<p className="card-header-date"></p>}
              >
                  {/*@ts-ignore*/}
                <AccountStatementForm authUser={authUser as any} />
              </Card>
            </Col>
            <Col span={24} md={16} className="mb-24">
              <YourTransaction authUser={authUser as any} />
            </Col>
      </Row>
    </>
  );
}

export default AccountActivity;
